import React, { useEffect, useRef, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ActionButton from '../../../../../Components/Common/ActionButton';
import {
  FileField,
  FormGrid,
  RequiredNote,
  TextField,
  focusFirstError,
  hasErrors,
  required,
  validateForm,
} from '../../../../../Components/Form';

const SCHEMA = {
  title: { label: 'Document title', rules: [required()] },
  file: { label: 'File', rules: [required()] },
};

const UploadDocumentModal = ({ isOpen, toggle, onSave }) => {
  const [title, setTitle] = useState('');
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState({});
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setTitle('');
      setFile(null);
      setErrors({});
    }
  }, [isOpen]);

  const validate = () => {
    const e = validateForm({ title, file }, SCHEMA);
    setErrors(e);
    if (hasErrors(e)) focusFirstError(e, ['title', 'file']);
    return !hasErrors(e);
  };

  const handleUpload = () => {
    if (!validate()) return;
    onSave({ title: title.trim(), file });
    toggle();
  };

  const handleFileChange = e => {
    const selected = e.target.files?.[0] ?? null;
    setFile(selected);
    if (selected) setErrors(prev => ({ ...prev, file: undefined }));
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Upload Document</ModalHeader>
      <ModalBody>
        <RequiredNote />
        <FormGrid columns={1}>
          <TextField
            label='Document title'
            name='title'
            required
            placeholder='e.g. Signed offer letter'
            value={title}
            error={errors.title}
            onChange={e => {
              setTitle(e.target.value);
              setErrors(prev => ({ ...prev, title: undefined }));
            }}
          />
          <FileField
            label='File'
            name='file'
            required
            inputRef={fileInputRef}
            error={errors.file}
            onChange={handleFileChange}
          />
        </FormGrid>
      </ModalBody>
      <ModalFooter>
        <ActionButton variant='secondary' icon='ri-close-line' onClick={toggle}>
          Cancel
        </ActionButton>
        <ActionButton
          variant='primary'
          icon='ri-upload-2-line'
          onClick={handleUpload}
        >
          Upload
        </ActionButton>
      </ModalFooter>
    </Modal>
  );
};

export default UploadDocumentModal;
